import React from 'react'
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from "./TaxlistTemplate.module.css"
export default function TaxlistTemplate({ item, index, editRedirect, deleteTax }) {
    return (
        <div className={styles.taxlistTemplatemain} key={item.id}>
            <div className={styles.taxlistTemplateImage}>
                <span>0{index + 1}</span>
            </div>
            <div className={styles.taxlistTemplateDesc}>
                <p><span>Rate:</span><span>{item.tax_rate}%</span></p>
                <p><span>Created At:</span><span>{item.created_at}</span></p>
                {item.status ? <button className={styles.success}>Active</button> : <button className={styles.danger}>Deactive</button>}
            </div>

            <div className={styles.taxlistTemplateedit}>
                <span className={styles.iconBtn} onClick={() => editRedirect(item.id)}>
                    <EditNoteRoundedIcon style={{ color: "#4c2fb3", fontSize: 18 }} titleAccess="Update" />
                </span>
                <span className={styles.iconBtn} onClick={() => deleteTax(item.id)}>
                    <DeleteIcon style={{ color: "#EF4444", fontSize: 18 }} titleAccess="Delete" />
                </span>
            </div>
        </div>
    )
}
